module.exports = __webpack_public_path__ + "static/media/boss-tuagom-pic-starting.6ed32636.png";